/* Anchor & Mane theme — storefront interactions (vanilla JS) */
(function () {
  "use strict";

  /* Mobile nav toggle */
  var toggle = document.querySelector(".menu-toggle");
  var nav = document.querySelector(".nav");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      nav.classList.toggle("open");
      toggle.setAttribute("aria-expanded", nav.classList.contains("open"));
    });
  }

  /* Product variant selection — drives the hidden select[name="id"] */
  document.querySelectorAll(".product-form").forEach(function (form) {
    var hidden = form.querySelector("[data-variant-id]");
    if (!hidden) return;
    var gate = form.closest("[data-price-gate]") || form.parentElement;
    var priceEl = gate ? gate.querySelector("[data-price]") : null;
    var addBtn = form.querySelector("[data-add-btn]");
    var controls = form.querySelectorAll("[data-option-index]");

    function selectedValues() {
      var vals = [];
      controls.forEach(function (c) {
        var idx = parseInt(c.getAttribute("data-option-index"), 10);
        var v = "";
        if (c.classList.contains("length-opts")) {
          var a = c.querySelector("button.is-active");
          v = a ? a.getAttribute("data-value") : "";
        } else {
          v = c.value;
        }
        vals[idx] = v;
      });
      return vals.join("||");
    }

    function update() {
      var target = selectedValues();
      var opts = hidden.options;
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].getAttribute("data-options") === target) {
          hidden.selectedIndex = i;
          if (priceEl && priceEl.firstChild) {
            priceEl.firstChild.nodeValue = opts[i].getAttribute("data-price") + " ";
          }
          var avail = opts[i].getAttribute("data-available") === "true";
          if (addBtn) {
            addBtn.disabled = !avail;
            addBtn.textContent = avail ? "Add to Cart" : "Sold Out";
          }
          return;
        }
      }
    }

    form.querySelectorAll(".length-opts").forEach(function (g) {
      g.addEventListener("click", function (e) {
        var b = e.target.closest("button");
        if (!b) return;
        e.preventDefault();
        g.querySelectorAll("button").forEach(function (x) { x.classList.remove("is-active"); });
        b.classList.add("is-active");
        update();
      });
    });
    form.querySelectorAll(".shade-select").forEach(function (s) {
      s.addEventListener("change", update);
    });
  });

  /* Product gallery thumbnail swap */
  var mainImg = document.querySelector(".pdp-gallery .main img");
  if (mainImg) {
    document.querySelectorAll(".pdp-gallery .thumbs .t img").forEach(function (t) {
      t.parentElement.addEventListener("click", function () {
        var tmp = mainImg.src; mainImg.src = t.src; t.src = tmp;
      });
    });
  }
})();
